/** Show stored instants in the applicant's timezone, including its zone name. */
export function ApplicationDeadline({
  opensAt,
  closesAt,
}: {
  opensAt?: string | null;
  closesAt?: string | null;
}) {
  return (
    <>
      {[
        { label: "Scheduled opening", instant: opensAt },
        { label: "Edits and submissions close", instant: closesAt },
      ].map(({ label, instant }) =>
        instant ? (
          <p key={label} className="body-sm text-muted-foreground">
            {label}{" "}
            <time dateTime={instant}>
              {new Date(instant).toLocaleString(undefined, {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                timeZoneName: "short",
              })}
            </time>
            .
          </p>
        ) : null,
      )}
    </>
  );
}
